import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import fr from './locales/fr.json';

const getBrowserLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  if (['es', 'en', 'fr'].includes(browserLang)) {
    return browserLang;
  }
  return 'es';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      fr: { translation: fr }
    },
    lng: localStorage.getItem('language') || getBrowserLanguage(),
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;